/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_c_friend_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the longest word you can make from the letters of FRIEND?`)
};

const es_wu_c_friend_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la palabra más larga que puedes formar con las letras de FRIEND?`)
};

const de_wu_c_friend_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist das längste Wort, das du aus den Buchstaben von FRIEND bilden kannst?`)
};

const nl_wu_c_friend_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het langste woord dat je kunt maken uit de letters van FRIEND?`)
};

const fr_wu_c_friend_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel est le mot le plus long que l'on peut former avec les lettres de FRIEND ?`)
};

const it_wu_c_friend_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la parola più lunga che puoi formare con le lettere di FRIEND?`)
};

const pt_br2_wu_c_friend_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a palavra mais longa que você pode formar com as letras de FRIEND?`)
};

const pt_wu_c_friend_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a palavra mais longa que se pode formar com as letras de FRIEND?`)
};

const ja_wu_c_friend_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FRIENDの文字から作れる最も長い単語は何ですか？`)
};

const zh_wu_c_friend_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用 FRIEND 的字母能拼出的最长单词是什么？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_c_friend_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_c_friend_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_c_friend_faq2_q", locale)
	if (locale === "en") return en_wu_c_friend_faq2_q(inputs)
	if (locale === "es") return es_wu_c_friend_faq2_q(inputs)
	if (locale === "de") return de_wu_c_friend_faq2_q(inputs)
	if (locale === "nl") return nl_wu_c_friend_faq2_q(inputs)
	if (locale === "fr") return fr_wu_c_friend_faq2_q(inputs)
	if (locale === "it") return it_wu_c_friend_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_wu_c_friend_faq2_q(inputs)
	if (locale === "pt") return pt_wu_c_friend_faq2_q(inputs)
	if (locale === "ja") return ja_wu_c_friend_faq2_q(inputs)
	return zh_wu_c_friend_faq2_q(inputs)
};